import {
  getDataFromServer,
  XMLHttpRequestFunc,
  putDataToServer,
  postDataToServer
} from '../../util';

export class CommonModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchAMLSCommonUnifiedAlertsAPI = async (payload) => {
    const url = `${this.baseURL}/alerts`;
    return await getDataFromServer(url, this.httpHeaders, payload);
  };

  fetchAMLSCommonUnifiedAlertsPreventionAPI = async (payload) => {
    const url = `${this.baseURL}/alerts/alertHistory`;
    return await getDataFromServer(url, this.httpHeaders, payload);
  };

  fetchAMLSCommonKYCAlertsAPI = async (payload) => {
    const { customerId = {} } = payload;
    const url = `${this.baseURL}/customers/${customerId}/similarKyc`;
    return await getDataFromServer(url, this.httpHeaders, payload);
  };

  fetchTypologiesActionsAPI = async () => {
    const url = `${this.baseURL}/fraudactions`;
    return await getDataFromServer(url, this.httpHeaders);
  };

  fetchAMLSCommonKYCDownloadAlertsAPI = async (payload) => {
    const { customerId = {} } = payload;
    const url = `${this.baseURL}/customers/${customerId}/similarKyc`;
    return await getDataFromServer(url, this.httpHeaders, payload);
  };

  fetchAMLSCommonAlertDetailsAPI = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonAlertPartyIdentityAPI = async (payload) => {
    const { alertId, isPrevention, ...params } = payload;
    let url = `${this.baseURL}/alerts/${alertId}/customer`;
    if (isPrevention) {
      url = `${this.baseURL}/alerts/${alertId}/customerlist`;
    }
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonAlertAssocCustomersAPI = async (payload) => {
    const { customerId, ...params } = payload;
    const url = `${this.baseURL}/customers/${customerId}/linkedCustomers`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonGetTicketsAPI = async (payload) => {
    const { sourceId, offset, limit } = payload;
    const params = {
      offset,
      limit
    };
    const url = `${this.baseURL}/tickets/all/${sourceId}`;
    return getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonApproveAndRejectTicketAPI = async (payload) => {
    let url = `${this.baseURL}/tickets/${payload.ticketId}?status=${payload.status}`;
    if (payload?.status === 'Rejected') {
      url += `&reason=${payload.reason}`;
    }
    return await putDataToServer(url, this.httpHeaders, {}, {});
  };

  updateAMLSCommonAlertPartyAPI = async (payload) => {
    const url = `${this.baseURL}/alerts/bulkUpdate`;
    return await putDataToServer(url, this.httpHeaders, undefined, payload);
  };

  fetchAMLSCommonSandboxUI = async (payload) => {
    const url = `http://13.0.0.132:9200/sandbox_watchlist_new/_search`;
    const dataStringify = JSON.stringify(payload);
    return await XMLHttpRequestFunc(url, dataStringify);
  };

  fetchAMLSCommonGetDynamicPropertiesCategoriesAPI = async (payload) => {
    const url = `${this.baseURL}/dyn-prop/categories`;
    const params = { ...payload };
    return getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonGetDynamicPropertiesAPI = async (payload) => {
    const url = `${this.baseURL}/dyn-prop/`;
    const params = { ...payload };
    return getDataFromServer(url, this.httpHeaders, params);
  };

  updateAMLSCommonPutDynamicPropertiesAPI = async (moduleId, payload) => {
    const url = `${this.baseURL}/dyn-prop/value`;
    const data = { ...payload };
    return putDataToServer(
      url,
      this.httpHeaders,
      { params: { moduleId } },
      data
    );
  };

  fetchAMLSCommonGetPipelinesAPI = async (payload) => {
    const url = `${this.baseURL}/pipelines`;
    const params = { ...payload };
    return getDataFromServer(url, this.httpHeaders, params);
  };

  fetchAMLSCommonPostPipelinesRunAPI = async ({ id, moduleId }) => {
    const url = `${this.baseURL}/pipelines/${id}/execute?moduleId=${moduleId}`;
    return postDataToServer(url, this.httpHeaders);
  };

  postAMLSCommonPostPipelinesScheduleAPI = async (payload) => {
    const data = payload?.data;
    const id = payload?.id;
    const moduleId = payload?.moduleId;
    const url = `${this.baseURL}/pipelines/schedule/${id}?moduleId=${moduleId}`;
    return postDataToServer(url, data);
  };

  postAMLSCommonPostPipelinesUnScheduleAPI = async (payload) => {
    const id = payload?.id;
    const moduleId = payload?.moduleId;
    const url = `${this.baseURL}/pipelines/unschedule/${id}?moduleId=${moduleId}`;
    return postDataToServer(url, id);
  };

  fetchAMLSCommonGetPipelinesScheduleInfoAPI = async (payload) => {
    const id = payload?.id;
    const moduleId = payload?.moduleId;
    const url = `${this.baseURL}/pipelines/schedule/${id}?moduleId=${moduleId}`;
    return getDataFromServer(url, this.httpHeaders);
  };

  fetchAMLSCommonGetPipelinesHistoryAPI = async (id, payload) => {
    const url = `${this.baseURL}/pipelines/${id}/executions`;
    return getDataFromServer(url, this.httpHeaders, payload);
  };

  postAMLSCommonPostPipelineStopAPI = async (payload) => {
    const id = payload?.id;
    const moduleId = payload?.moduleId;
    const url = `${this.baseURL}/pipelines/${id}/stop?moduleId=${moduleId}`;
    return postDataToServer(url, id);
  };

  fetchBlackList = async () => {
    const url = `${this.baseURL}/blacklists`;
    return await getDataFromServer(url, this.httpHeaders, {});
  };

  fetchAMLSCommonGetNotificationsAPI = async () => {
    const url = `${this.baseURL}/notifications`;
    return getDataFromServer(url, this.httpHeaders);
  };
}
